import Player from '@vimeo/player'

export default class VideoModal {
    constructor () {
        this.modals = document.querySelectorAll('.modal-video')

        // If there's no video modals, return
        if (!this.modals)
            return

        this.modals.forEach(modal => this.control(modal))
    }

    control (el) {
        const iframe = el.querySelector('iframe')
        const video = el.querySelector('video')
        const vimeo = iframe
            && iframe.src.includes('vimeo')

        if (!video && !vimeo)
            return

        const videoPlayer = vimeo
            ? new Player(iframe)
            : video

        el.addEventListener('shown.bs.modal', () => videoPlayer.play())

        el.addEventListener('hide.bs.modal', () => videoPlayer.pause())
    }
}
